import { base, TABLES, FIELDS } from '../config';

export class FormSubmissionModel {
  static get table() {
    if (!base) {
      throw new Error('Airtable is not properly configured. Please check your environment variables.');
    }
    return base(TABLES.FORM_SUBMISSIONS);
  }

  static fields = FIELDS.FORM_SUBMISSIONS;

  static async create(data) {
    try {
      // Check if Airtable is configured
      if (!base) {
        console.error('Airtable is not configured');
        throw new Error('Unable to submit form. Please try again later.');
      }

      // Log the incoming data
      console.log('Form Data Received:', {
        serviceType: data.serviceType,
        deploymentPreference: data.deploymentPreference,
        projectTimeline: data.projectTimeline
      });

      // Base fields that are always included
      const fields = {
        [this.fields.NAME]: data.name,
        [this.fields.EMAIL]: data.email,
        [this.fields.COMPANY]: data.company,
        [this.fields.MESSAGE]: data.message,
        [this.fields.SERVICE_TYPE]: data.serviceType,
        [this.fields.SUBMISSION_DATE]: new Date().toISOString(),
      };

      // Add service-specific fields
      if (data.serviceType === "Product") {
        fields[this.fields.CURRENT_AI_SOLUTION] = data.currentAiSolution;
      } else if (data.serviceType === "Consulting") {
        fields[this.fields.PROJECT_TIMELINE] = data.projectTimeline;
        fields[this.fields.INDUSTRY_FOCUS] = data.industryFocus;
        fields[this.fields.DEPLOYMENT_PREFERENCE] = data.deploymentPreference;
      }

      // Log the exact fields being sent to Airtable
      console.log('Sending to Airtable:', {
        serviceType: fields[this.fields.SERVICE_TYPE],
        deploymentPreference: fields[this.fields.DEPLOYMENT_PREFERENCE],
        projectTimeline: fields[this.fields.PROJECT_TIMELINE]
      });

      const record = await this.table.create([{ fields }]);
      return record;
    } catch (error) {
      console.error('Error creating form submission:', error);
      // Log the error details
      if (error.message.includes('INVALID_MULTIPLE_CHOICE_OPTIONS')) {
        console.log('Invalid choice error details:', {
          message: error.message,
          statusCode: error.statusCode,
          error: error.error
        });
      }
      throw error;
    }
  }

  static async getAll() {
    try {
      // Check if Airtable is configured
      if (!base) {
        console.error('Airtable is not configured');
        throw new Error('Unable to fetch submissions. Please try again later.');
      }

      const records = await this.table.select().all();
      return records.map(record => ({
        id: record.id,
        ...record.fields,
      }));
    } catch (error) {
      console.error('Error fetching form submissions:', error);
      throw error;
    }
  }

  // Add more methods as needed
}
